<template>
  <div class="outline">
    <b-button-toolbar>
      <b-button variant="outline" @click="showMgr = !showMgr" title="Vytotaler">
        <b-icon-gear></b-icon-gear>
        <!-- <b-icon-segmented-nav></b-icon-segmented-nav> -->
      </b-button>
      <b-button v-if="buttons&&buttons.length>0"  variant="outline" @click="UpdateAll()" title="Uppdatera vytotaler"><b-icon-arrow-repeat></b-icon-arrow-repeat> </b-button>

      <queryviewbutton
        v-for="(b, i) in buttons"
        :key="i"
        v-bind:button="b"
        v-bind:refresher="refresher"
        @click="select(b)"
      ></queryviewbutton>      
    </b-button-toolbar>
    <b-modal
      title="Hantera vytotaler"
      v-model="showMgr"
      ok-only
      ok-title="Stäng"
      @ok="showMgr = false"
      size="xl"
    >
      <div v-if="showMgr">
        <!-- <b-row>
          <b-col>
            <b-button @click="Save()">Spara</b-button>
            &nbsp;
            <b-button @click="Refresh()">Avbryt</b-button>
          </b-col>
        </b-row>
        <hr /> -->
        <b-row>
          <b-col cols="2">Lägg till:</b-col>
          <b-col cols="2">
            <b-select
              v-model="qvToAdd"
              :options="getQueryViews()"
              @change="addNewButton()"
            ></b-select>
          </b-col>
        </b-row>
        <b-card v-for="(b, i) in buttons" :key="i">
          <b-row>
              <b-col cols="1">
                  <b-button variant="outline" title="Flytta upp" @click="Move(i,-1)"><b-icon-caret-up></b-icon-caret-up></b-button>
              <b-button variant="outline" title="Flytta ned" @click="Move(i,1)"><b-icon-caret-down></b-icon-caret-down></b-button>
              </b-col>
            <b-col cols="2">
              <queryviewbutton :button="b" v-bind:refresher="refresher"></queryviewbutton><br>
              
            </b-col>
            <b-col>
              <b-button-toolbar>
                <b-button @click="RemoveButton(i)">Ta bort</b-button>
              </b-button-toolbar>
              <!-- <label>Titel:</label><b-input v-model="b.title"></b-input> -->
              <br />
              <b-row>
                <b-col>
                  <label>Vytotaler:</label>
                </b-col>
                <b-col>
                  <b-button                    
                    @click="setCurrEdit(b.queryid)"
                    v-if="
                      !(currEditId && currEditId == b.queryid && avaiableCols)
                    "
                    ><b-icon-plus></b-icon-plus
                  >Lägg till</b-button>
                  <b-select
                    v-if="currEditId && currEditId == b.queryid && avaiableCols"
                    v-model="currColAdd"
                    v-bind:options="getAvailableCols(b.queryid)"
                    @change="addCol(b)"
                  ></b-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <label>Kolumn:</label>
                </b-col>
                <b-col cols="2">
                  <label>Operation:</label>
                </b-col>
                <!-- <b-col>
                  <label>Titel:</label>
                </b-col> -->
                <b-col></b-col>
              </b-row>
              <b-row v-for="(c, ci) in b.cols" :key="ci">
                <b-col cols="3">
                  {{ c.prettyname }}
                </b-col>
                <b-col cols="2">
                  <b-select v-model="c.op" :options="operations" @change="Save"></b-select>
                </b-col>
                <!-- <b-col>
                  <b-input v-model="c.title"></b-input>
                </b-col> -->
                <b-col>
                  <b-icon-x-circle @click="removeCol(b, ci)"></b-icon-x-circle>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </b-modal>
  </div>
</template>
<script>
import queryviewbutton from "./queryviewbutton";
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "queryviewbuttonpanel",
  components: { queryviewbutton },
  props: {
    qvtype: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      buttons: [],
      refresher: 0,
      editMode: false,
      currEditId: null,
      currColAdd: null,
      showMgr: false,
      operations: [        
        { value: "COUNT", text: "Antal" },
        { value: "SUM", text: "Summa" },
        { value: "MIN", text: "Min" },
        { value: "MAX", text: "Max" },
        { value: "AVG", text: "Medel" },
        { value: "AVG0", text: "Medel (inkludera tomma)" },    
      ],
      avaiableCols: [],
      qvlist: [],
      qvToAdd: null,
    };
  },
  created() {
    api
      .get("/api/apiqueryview/GetQueryViewList?queryviewtype=" + this.qvtype)
      .then((res) => {
        this.qvList = res.data;
      });
    this.Refresh();
  },
  methods: {
    Refresh() {
      //Format: [{qvtype: '', buttons: []}]
      var ls = localStorage.getItem("qvpanels_"+this.qvtype);
      this.buttons = [];
      if (ls) {
         this.buttons = JSON.parse(ls);        
      }
    },
    Save() {      
      var ls = localStorage.setItem("qvpanels_"+this.qvtype, JSON.stringify(this.buttons));
      this.UpdateAll();
    },
    select(b) {
      //alert('select');
      this.$emit("select", b);
    },
    getAvailableCols(id) {
      if (this.avaiableCols) {
        return this.avaiableCols.map((x) => {
          return { text: x.Name, value: x.ColName };
        }).sort((a,b)=> (a.text > b.text)? 1:-1);
      }
      return null;
    },
    updateAvailableCols(id) {
      if (this.avaiableCols)
        this.avaiableCols = this.avaiableCols.find((x) => x.queryId != id); //Remove old
      api.get("/api/apiqueryview/GetQueryViewColumns?id=" + id).then((res) => {
        if (!this.avaiableCols) this.avaiableCols = [];
        this.avaiableCols = res.data;
      });
    },
    setCurrEdit(queryId) {
      this.avaiableCols = null;
      this.currEditId = queryId;
      this.updateAvailableCols(queryId);
    },
    addCol(b) {
      if (!b.cols) b.cols = [];
      var c = this.avaiableCols.find((x) => x.ColName == this.currColAdd);

      b.cols.push({
        colname: this.currColAdd,
        op: this.operations[0].value,
        prettyname: c.Name,
        title: c.Name,
      });
      this.currColAdd = null;
      this.currEditId = null;
      this.Save();
    },
    removeCol(b, idx) {
      //console.log("Remove col");
      b.cols.splice(idx, 1);
      //this.$forceUpdate();
      this.Save();
    },
    getQueryViews() {
      if (this.qvList) {
        var arr = this.qvList;
        if (this.buttons)
          arr = arr.filter(
            (x) => this.buttons.findIndex((b) => b.qvList == x.id) < 0
          );
        return arr.map((x) => {
          return { value: x.id, text: x.name };
        });
      }
    },
    addNewButton() {
      if (!this.buttons) this.buttons = [];

      var qv = this.qvList.find((x) => x.id == this.qvToAdd);
      var newButton = {
        queryid: this.qvToAdd,
        title: qv.text,
      };
      this.buttons.unshift(newButton);
      this.qvToAdd = null;
      this.Save();
    },
    RemoveButton(idx) {
        this.buttons.splice(idx,1);
        this.Save();
    },
    UpdateAll() {
        this.refresher++;        
    }, 
    Move(idx,steps) {
        
        var newPos = idx+steps;
        if(newPos<0||newPos>=this.buttons.length)
            return;
        var tmp = this.buttons[idx];
        this.buttons[idx]=this.buttons[newPos];
        this.buttons[newPos]=tmp;
        this.Save();
    }
  },
};
</script>